import apiService from './apiService';

/**
 * Service for managing alert snooze rules
 */
class SnoozeService {
  /**
   * Get all active snooze rules for the organization
   */
  async getActiveSnoozes() {
    return apiService.get('/snooze');
  }

  /**
   * Create a new snooze rule
   * @param {Object} snoozeData - Snooze configuration
   * @param {string} snoozeData.snooze_type - Type: 'table', 'metric', 'validation_rule', 'connection', 'pattern'
   * @param {string} snoozeData.target_id - Identifier for the target
   * @param {number} snoozeData.duration_minutes - How long to snooze
   * @param {string} [snoozeData.target_name] - Human-readable name
   * @param {string} [snoozeData.reason] - Reason for snoozing
   * @param {string} [snoozeData.connection_id] - Optional connection ID
   */
  async createSnooze(snoozeData) {
    return apiService.post('/snooze', snoozeData);
  }

  /**
   * Quick snooze using predefined duration
   * @param {Object} snoozeData - Snooze configuration
   * @param {string} snoozeData.snooze_type - Type of snooze
   * @param {string} snoozeData.target_id - Target identifier
   * @param {string} snoozeData.duration_key - One of: '1h', '4h', '8h', '24h', '1d', '3d', '1w', '2w'
   * @param {string} [snoozeData.target_name] - Display name
   */
  async quickSnooze(snoozeData) {
    return apiService.post('/snooze/quick', snoozeData);
  }

  /**
   * Cancel/delete a snooze rule
   * @param {string} snoozeId - ID of the snooze rule to cancel
   */
  async cancelSnooze(snoozeId) {
    return apiService.delete(`/snooze/${snoozeId}`);
  }

  /**
   * Extend an existing snooze
   * @param {string} snoozeId - ID of the snooze rule
   * @param {number} additionalMinutes - Minutes to add
   */
  async extendSnooze(snoozeId, additionalMinutes) {
    return apiService.post(`/snooze/${snoozeId}/extend`, {
      additional_minutes: additionalMinutes
    });
  }
}

const snoozeService = new SnoozeService();
export default snoozeService;
